import axios from 'axios'
import jwtToken from './getJwtToken'

const DASHBOARD_API_URL = process.env.VUE_APP_DASHBOARD_API_URL

export default axios.create({
  baseURL: `${DASHBOARD_API_URL}`,
  headers: {
    Authorization: `Bearer ${jwtToken}`,
    Accept: 'application/ld+json',
    'Content-Type': 'application/ld+json',
  },
})
